import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	removeOption: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.field-with-options.option.remove-option',
		defaultMessage: 'Remove option',
		description: 'Button to remove existing option in Dropdown field settings',
	},
	disabledInputTooltip: {
		id: 'issue-type-page.field-associated.field-configuration.field-options.option.disabled-input-tooltip',
		defaultMessage: 'You can’t change this option',
		description: "Tooltip shown when a user can't edit an option",
	},
	disabledSortHandleTooltip: {
		id: 'issue-type-page.field-associated.field-configuration.field-options.option.disabled-sort-handle-tooltip',
		defaultMessage: 'You can’t reorder the options',
		description: "Tooltip shown when a user can't reorder an option",
	},
	disabledRemoveButtonTooltip: {
		id: 'issue-type-page.field-associated.field-configuration.field-options.option.disabled-remove-button-tooltip',
		defaultMessage: 'You can’t remove this option',
		description: "Tooltip shown when a user can't remove an option",
	},
	draggableItemRole: {
		id: 'issue-type-page.field-associated.field-configuration.field-options.option.draggable-item-role',
		defaultMessage: 'Draggable item',
		description: 'Text describing role of a button',
	},
});
